import React from 'react';
import { createCollection } from '@radix-ui/react-collection';
function createCollectionIndex(name) {
    const COLLECTION_INDEX_NAME = name + 'CollectionIndex';
    const [Collection, useCollection, createCollectionScope] = createCollection(COLLECTION_INDEX_NAME);
    /* -----------------------------------------------------------------------------------------------
     * useCollectionIndex
     * --------------------------------------------------------------------------------------------- */
    function useCollectionIndex(currentRef, scope) {
        const getItems = useCollection(scope);
        return React.useCallback(() => {
            return getItems().findIndex(({ ref }) => ref.current === currentRef.current);
        }, [getItems, currentRef]);
    }
    return [Collection, useCollectionIndex, createCollectionScope];
}
export { createCollectionIndex };
